import baseStyled from '@emotion/styled';
import { useTheme as baseUseTheme, css as baseCss } from '@emotion/react';
export { ThemeContext, Global } from '@emotion/react';
export var styled = baseStyled;
export var css = baseCss;
export var useTheme = baseUseTheme;
export { ThemeProvider } from "./ThemeProvider";
//# sourceMappingURL=styled.js.map